import { Form, Formik, useFormikContext } from 'formik'
import * as Yup from 'yup'
import { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { BudgetContext } from '../../../../lib/Context'
import { Reconciliation, Spend } from '../../../../lib/Types'
import Headline from '../../../Elements/Headline'
import { Modal } from '../../../Elements/Modal'
import Textarea from '../../../Formik/Textarea'
import Button from '../../../Formik/Button'
import { isCurrency } from '../../../../lib/Validations'
import { useUpdateBudgetReconciliation } from '../../lib/Hooks/Budget'
interface Props {
  hideModal: () => void
  reconciliation: Reconciliation | null
  spend: Spend | null
}

const ReconciliationModal: FC<Props> = ({ hideModal, reconciliation, spend }) => {
  const { t } = useTranslation(['budget', 'common'])
  const { mutate: saveReconciliation, isPending: isLoading } = useUpdateBudgetReconciliation()
  const { reconciliationYear } = useContext(BudgetContext)

  if (!spend) return null

  return (
    <>
      <Modal show={reconciliation !== null} onHide={hideModal}>
        {(closeModal: any) => (
          <>
            <Headline className="mb-4">
              {t('budget:reconciliationModal.titlePrefix')}{' '}
              <strong>{spend.title}</strong>{' '}
              {t('budget:reconciliationModal.titleMiddle')}{' '}
              <strong>{reconciliationYear}</strong>
            </Headline>
            <Formik
              initialValues={{ formula: reconciliation ? reconciliation.formula.replaceAll('.', ',') : '' }}
              validationSchema={Yup.object({
                formula: Yup.string()
                  .transform((currentValue) => {
                    // First remove all danish thousand seperators (.) and then replace the danish delimiter seperator (,) with the english one (.).
                    // This way it's possible to save floats.
                    return currentValue.replaceAll('.', '').replaceAll(',', '.')
                  })
                  .required(t('common:validation.required'))
                  .test(isCurrency),
              })}
              onSubmit={async (values) => {
                reconciliation!.formula = values.formula
                  .replaceAll('.', '')
                  .replaceAll(',', '.')

                saveReconciliation(reconciliation!)

                closeModal()
              }}
            >
              <Form>
                <div className="flex flex-row">
                  <span className="mr-2">=</span>
                  <ReconciliationTextArea />
                </div>
                <Button type='submit' className='mt-5' loading={isLoading}>
                  {t('budget:shared.save')}
                </Button>
              </Form>
            </Formik>
          </>
        )}
      </Modal>
    </>
  )
}

const ReconciliationTextArea = () => {
  const { t } = useTranslation(['budget'])
  const { setFieldValue } = useFormikContext<any>()

  return (
    <Textarea
      name="formula"
      placeholder={t('budget:reconciliationModal.amountPlaceholder')}
      onBlur={(event) => {
        setFieldValue('formula', event.target.value.replaceAll(' ', ''))
      }}
    />

  )
}

export default ReconciliationModal
